
<nav class="navbar" role="navigation" aria-label="main navigation" id="main-nav-bar-menu">
  <div class="navbar-brand">
    <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicTop"
       (click)="toggleMenu()">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicTop" class="navbar-menu" [ngClass]="{'is-active': isMenuOpen}">
    <a class="navbar-item is-size-6" (click)="toggleMenu()"
       routerLink="/">{{ 'menu.fnol.label' | localize }}</a>
    <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
       routerLink="/forms/submit/earthquake">{{ 'Earthquake' | localize }}</a>
    <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
       routerLink="/forms/submit/flood">{{ 'Flood' | localize }}</a>
    @if (isFormManager) {
      <a class="navbar-item is-size-6 has-text-weight-semibold" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
         routerLink="/admin/forms">{{ 'menu.admin' | localize }}</a>
    }

    <div class="navbar-end">
      <div class="navbar-item">
        <app-language-selector/>
      </div>
      @if (isAuthenticated) {
        <div class="navbar-item has-text-link is-size-6">
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-user-circle"></i>
              </span>
              <span><a routerLink="/user/me"
                       routerLinkActive="has-background-grey-lighter">{{ getUsername() }}</a></span>
            </span>
        </div>
        <div class="buttons navbar-item is-size-6">
          <a class="button is-dark" (click)="triggerLogout()">{{ 'button.logout.label' | localize }}</a>
        </div>
      } @else if (!isAuthenticated) {
        <div class="navbar-item">
          <a class="button has-text-black has-background-white-ter" (click)="initiateLogin()">{{ 'button.login.label' | localize }}</a>
        </div>
      }
    </div>

  </div>
</nav>

